<template>
    <fragment>
        <component
            :is="info.enabledClicked && index < step ? 'button' : 'div'"
            v-if="step > index"
            class="rounded-full h-8 w-8 flex items-center justify-center bg-theme-success btn p-0"
            @click="onClick"
        >
            ✔
        </component>
        <div
            v-else
            class="rounded-full h-8 w-8 flex items-center justify-center"
            :class="step == index ? 'bg-theme-primary' : 'bg-theme-disabled'"
        >
            <span class="text-white">
                {{ index + 1 }}
            </span>
        </div>

        <span
            class="text-center mt-1 font-semibold"
            :class="{
                'text-primary': step == index,
                'text-secondary': step < index,
                'text-theme-primary': step > index
            }"
        >
            {{ info.name }}
        </span>
    </fragment>
</template>

<script>
export default {
    name: "StepViewer",
    props: {
        step: {
            default: () => 1,
            required: true,
            type: Number
        },
        index: {
            default: () => 1,
            required: true,
            type: Number
        },
        info: {
            default: () => ({
                name: "",
                enabledClicked: true
            }),
            required: true,
            type: Object
        }
    },
    emit: ["click"],
    methods: {
        onClick() {
            if (this.info.enabledClicked && this.index < this.step) {
                this.$emit("click", this.index);
            }
        }
    }
};
</script>
